/* @flow */

import { MAX_TABLET_GRID_WIDTH } from 'src/shared/app/base/style/token/grid';
import { listReset } from 'src/shared/app/base/style/token/helper';
import type { ThemeFunction } from 'src/shared/app/base/types/themeTypes';

export default {
  feed: {
    ...listReset,

    margin: [0, 'auto'],
    maxWidth: MAX_TABLET_GRID_WIDTH,
  },
  feedItem: {
    margin: ({ isCompact }: ThemeFunction<{ isCompact: boolean }>) =>
      isCompact ? 'unset' : '0 0 30px',

    ['&:last-of-type']: {
      marginBottom: ({ isCompact }: ThemeFunction<{ isCompact: boolean }>) =>
        isCompact ? 12 : 30,
    },
  },
};
